function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M865.718,394.873a9.15,9.15,0,0,0-6.406-7.858,5.932,5.932,0,1,0-5.389,0,9.151,9.151,0,0,0-6.406,7.858.672.672,0,0,0,.669.735h0a.671.671,0,0,0,.668-.607,7.747,7.747,0,0,1,1.3-3.607,7.826,7.826,0,0,1,3.433-2.827,7.786,7.786,0,0,1,7.4.719,7.824,7.824,0,0,1,2.827,3.433,7.713,7.713,0,0,1,.577,2.283.672.672,0,0,0,1.337-.129Zm-9.1-8.556a4.57,4.57,0,1,1,1.786-.36A4.557,4.557,0,0,1,856.617,386.318Z",
  transform: "translate(-847.513 -375.797)",
  fill: "#fff"
});

var SvgNoPassenger = function SvgNoPassenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.208,
    height: 19.812,
    viewBox: "0 0 18.208 19.812",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoPassenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-passenger.65482719.svg";
export { ForwardRef as ReactComponent };